var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { css } from '@emotion/css';
import { FlexBox, ModalDialogFooter, tokens } from '@vp/swan';
const studioModalFooterButtonsStyles = css `
    && {
        display: flex;
        align-items: center;
        gap: ${tokens.SwanSemSpaceBetweenActions};

        @media ${tokens.SwanSemMqLtSm.replace(/'/gi, '')} {
            flex-direction: column;
            justify-content: space-between;
            text-align: center;
            align-items: stretch;
        }
    }
`;
const studioModalFooterStyles = css `
    && {
        border: none;
        margin-top: 0;
        padding-top: 0;
    }
`;
export const StudioModalFooter = (_a) => {
    var { children, className, alignButtonsCenter } = _a, rest = __rest(_a, ["children", "className", "alignButtonsCenter"]);
    return (_jsx(ModalDialogFooter, Object.assign({ className: studioModalFooterStyles }, rest, { children: _jsx(FlexBox, Object.assign({ className: studioModalFooterButtonsStyles }, { children: children })) })));
};
//# sourceMappingURL=StudioModalFooter.js.map